import React from 'react';
import { ColorRing, ThreeDots } from "react-loader-spinner";

function MaestroLoader(props) {
    const {style = {}, ...restProps} = props;

    let centeredStyle = {
        // marginLeft: '50%',
        // transform: 'translateX(-50%)',
        alignSelf: 'center',
    };

    // react-loader-spinner wrapperStyle doesn't support arrays
    let wrapperStyle = {
        ...(props.centered ? centeredStyle : {}),
        ...style,
    };

  return (
    <ThreeDots
        visible={true}
        height="40"
        width="40"
        ariaLabel="Loading"
        wrapperStyle={wrapperStyle}
        wrapperClass="color-ring-wrapper"
        color="#BD2025"
        colors={['#BD2025', '#6BABAE', '#C66B6E', '#62B995', '#7E6EAD']}
        {...restProps}
        />
    );
}

/*
function MaestroLoader(props) {
    return (<div className={`loader ${props.mmSize} ${props.mmColor} ${props.mmWrapper ? 'has-wrapper' : 'no-wrapper'}`}></div>)
}

MaestroLoader.defaultProps = {
    mmSize: 'default',
    mmColor: 'fuchsia',
    mmWrapper: 'no-wrapper',
};
*/

export default MaestroLoader;
